import { Controller } from "@hotwired/stimulus"

export default class ActiveLinkController extends Controller {
  static values = {
    activeClass: { type: String, default: "active" },
  }

  declare activeClassValue: string
  private observer?: MutationObserver

  connect() {
    this.#syncActive(document.location)

    let oldHref = document.location.href
    this.observer = new MutationObserver(() => {
      if (oldHref !== document.location.href) {
        this.#syncActive(document.location)
        oldHref = document.location.href
      }
    })

    this.observer.observe(document, { attributes: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  #syncActive(location: Location) {
    if (this.#isActive(location)) {
      this.element.classList.add(this.activeClassValue)
    } else {
      this.element.classList.remove(this.activeClassValue)
    }
  }

  #isActive(location: Location) {
    const href = this.element.getAttribute("href")
    const pathnameWithoutFormat = location.pathname.replace(/\.[^/.]+$/, "") // Remove format like .json, .html, etc.
    return pathnameWithoutFormat === href
      || pathnameWithoutFormat.startsWith(`${href}/`)
      || pathnameWithoutFormat.startsWith(`${href}?`)
  }
}
